export default {
  metadata: {
    version: '1.0.0',
    id: 'pagination-1.0.0',
    name: 'JDSPagination'
  },
  hierarchy: {
    container: [
      'first-jds_button',
      'previous-jds_button',
      {
        'basic-container': ['data-jds_pagination_button']
      },
      {
        'compact-container': ['helper-jds-text']
      },
      'next-jds_button',
      'last-jds_button'
    ]
  },
  base: {
    container: {
      hidden: false,
      'background-color': '{p_0}',
      'flex-direction': '{p_1}',
      'justify-content': '{p_2}',
      'align-items': '{p_3}',
      'padding-left': '{p_4}',
      'padding-right': '{p_5}',
      width: '{p_6}',
      'min-height': '{p_7}'
    },
    'basic-container': {
      'flex-direction': '{p_8}'
    },
    'previous-jds_button': {
      icon: 'ic_back',
      kind: 'tertiary',
      size: 'small',
      _hasLabel: false
    },
    'next-jds_button': {
      icon: 'ic_next',
      kind: 'tertiary',
      size: 'small',
      _hasLabel: false
    },
    'last-jds_button': {
      hidden: true,
      icon: 'ic_lastpage',
      kind: 'tertiary',
      size: 'small',
      _hasLabel: false
    },
    'first-jds_button': {
      hidden: true,
      icon: 'ic_firstpage',
      kind: 'tertiary',
      size: 'small',
      _hasLabel: false
    },
    'compact-container': {
      'flex-direction': '{p_9}',
      hidden: true,
      gap: '{p_10}',
      'padding-left': '{p_11}',
      'padding-right': '{p_12}'
    },
    'helper-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    kind: {
      compact: {
        'compact-container': {
          hidden: false
        },
        'basic-container': {
          hidden: true
        },
        'last-jds_button': {
          hidden: false
        },
        'first-jds_button': {
          hidden: false
        }
      }
    }
  },
  api: {
    config: {
      kind: {
        values: ['basic', 'compact']
      }
    },
    data: {
      container: {
        '_items.page': {
          type: 'number',
          name: 'page'
        },
        '_items.totalPages': {
          type: 'number',
          name: 'totalPages'
        }
      },
      'basic-container': {
        value: {
          type: 'list',
          name: '_items',
          object: {
            text: 'string',
            state: 'JDSPaginationButton.state'
          }
        }
      },
      'data-jds_pagination_button': {
        text: {
          type: 'string',
          name: '_items.text'
        },
        state: {
          type: 'JDSPaginationButton.state',
          name: '_items.state'
        }
      },
      'first-jds_button': {
        disabled: {
          type: 'boolean',
          name: '_firstDisabled'
        }
      },
      'previous-jds_button': {
        disabled: {
          type: 'boolean',
          name: '_previousDisabled'
        }
      },
      'next-jds_button': {
        disabled: {
          type: 'boolean',
          name: '_nextDisabled'
        }
      },
      'last-jds_button': {
        disabled: {
          type: 'boolean',
          name: '_lastDisabled'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: '_helperText'
        }
      }
    },
    events: {
      'first-jds_button': {
        onClick: 'onFirst'
      },
      'previous-jds_button': {
        onClick: 'onPrevious'
      },
      'next-jds_button': {
        onClick: 'onNext'
      },
      'last-jds_button': {
        onClick: 'onLast'
      },
      'data-jds_pagination_button': {
        onClick: 'onSelect'
      }
    },
    a11y: {
      'previous-jds_button': {
        properties: {
          ariaLabel: {
            name: 'previousButtonAriaLabel',
            value: 'Previous Page'
          }
        }
      },
      'next-jds_button': {
        properties: {
          ariaLabel: {
            name: 'nextButtonAriaLabel',
            value: 'Next Page'
          }
        }
      },
      'last-jds_button': {
        properties: {
          ariaLabel: {
            name: 'lastButtonAriaLabel',
            value: 'Last Page'
          }
        }
      },
      'first-jds_button': {
        properties: {
          ariaLabel: {
            name: 'firstButtonAriaLabel',
            value: 'First Page'
          }
        }
      },
      container: {
        properties: {
          role: {
            value: 'navigation'
          },
          'aria-label': {
            name: 'ariaLabel',
            value: 'Pagination navigation'
          },
          'aria-describedby': 'ariaDescribedby'
        }
      }
    }
  }
};
